export default "__VITE_ASSET__c145fa0b__"